import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  margin-top: 1rem;
  padding: 1rem;
  flex-direction: column;
  border-radius: 0.5rem;
  background-color: #ffffff; /* Substitua pela cor desejada */
`;

export default Container;